<template>
  <div>
    <v-dialog v-model="isOpen" width="600" persistent>
      <v-card>
        <v-card-title class="d-flex align-center justify-space-between">
          <h1>{{ dialogTitle }}</h1>
          <v-btn icon @click="close()" class="align-self-end">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="isNegociationLoading" class="d-flex justify-center py-12">
            <v-progress-circular color="primary" indeterminate class="py-12" />
          </div>
          <v-form v-else :key="forceReset" ref="tariffForm">
            <v-row>
              <v-col cols="12">
                <v-radio-group v-model="selectedType" row hide-details :disabled="isEdit">
                  <template #label> Tipo: </template>
                  <v-radio label="Município" value="city"></v-radio>
                  <v-radio label="Cnpj" value="cnpj"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row v-if="isCnpjNegociation">
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="cpfOrCnpj"
                  label="CNPJ (Obrigatório)"
                  :rules="[rules.required]"
                  v-mask="'##.###.###/####-##'"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" md="6">
                <v-select
                  v-model="stateId"
                  label="Estado (Obrigatório)"
                  :items="getStates"
                  item-text="name"
                  item-value="id"
                  @change="fetchCitiesByID"
                  :rules="[rules.required]"
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="cityId"
                  label="Cidade (Obrigatório)"
                  :items="getCities"
                  item-text="name"
                  item-value="id"
                  :disabled="!stateId"
                  :loading="loadingCity"
                  :rules="[rules.required]"
                >
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" v-if="!isPercentage">
                <v-text-field v-model="value" v-money="money" label="Valor"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="isPercentage">
                <v-text-field
                  v-model="percentage"
                  ref="percentageField"
                  v-money="moneyPercentage"
                  :rules="[rules.hasPercentage]"
                  label="Porcentagem (Obrigatório)"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="isPercentage">
                <v-text-field v-model="valueMin" v-money="money" label="Valor Mínimo"></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="d-flex justify-center pb-4">
          <v-btn @click="close()" color="error" class="flex-grow-1"> CANCELAR </v-btn>
          <v-btn
            @click="onSubmitConfirm()"
            :loading="isButtonLoading"
            :disabled="shouldDisableAddButton"
            color="success"
            class="flex-grow-1"
          >
            SALVAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <MessagesError :errors="errors" @closeMessages="errors = []" :type="errorsType" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { VMoney } from 'v-money';
import MessagesError from '@/components/MessagesError.vue';
import removeCaracters from '@/utils/removeCaracters';
import removePriceMask from '@/utils/removePriceMask';
import removePercentageMask from '@/utils/removePercentageMask';
import { stringToMoneyMask } from '@/handlers/MoneyHandler';
export default {
  components: {
    MessagesError
  },

  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    typeNegotiation: null,
    negociationIdToEdit: {
      type: Object,
      default: null
    }
  },

  directives: { money: VMoney },

  data: () => ({
    isButtonLoading: false,
    isNegociationLoading: false,
    forceReset: 0,
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: false
    },
    moneyPercentage: {
      decimal: '.',
      thousands: '',
      prefix: '',
      suffix: '%',
      precision: 2,
      masked: false
    },
    selectedType: 'city',
    errors: [],
    errorsType: 'error',
    value: null,
    valueMin: null,
    percentage: null,
    loadingCity: false,
    loadingToCreate: false,
    types: [
      { name: 'Município', id: 1 },
      { name: 'CNPJ', id: 0 }
    ],
    type: 1,
    stateId: '',
    cityId: '',
    cpfOrCnpj: null,
    rules: {
      required: (value) => !!value || 'Campo obrigatório!',
      hasPercentage: (value) => {
        return (value !== null && value !== '0.00%') || 'Campo obrigatório!';
      }
    }
  }),

  computed: {
    ...mapGetters('AdressStore', ['getStates', 'getCities']),
    isCnpjNegociation() {
      return this.selectedType === 'cnpj';
    },
    negotiationId() {
      return this.$route.params.id;
    },
    isEdit() {
      return this.negociationIdToEdit !== null;
    },
    isPercentage() {
      return this.typeNegotiation == 'Percentual';
    },
    dialogTitle() {
      return `${this.isEdit ? 'Editar' : 'Nova'} tarifa`;
    },

    shouldDisableAddButton() {
      return (
        (this.cityId == null && !this.isCnpjNegociation) ||
        (this.stateId == null && !this.isCnpjNegociation) ||
        (!this.cpfOrCnpj && this.isCnpjNegociation) ||
        (this.cpfOrCnpj && removeCaracters(this.cpfOrCnpj).length < 14 && this.isCnpjNegociation) ||
        (this.transformPercentageToSend(this.percentage) === 0 && this.isPercentage)
      );
    }
  },

  watch: {
    isOpen: {
      handler(isOpen) {
        if (isOpen && this.isEdit) {
          this.fetchMyNegotiationByID();
        } else {
          this.resetNegociation();
        }
      }
    }
  },

  mounted() {
    this.fetchAllStates();

    if (this.typeRoute) {
      this.type = Number(this.typeRoute);

      this.fetchMyNegotiationByID();
    } else {
      this.isNegociationLoading = false;
    }
  },

  methods: {
    ...mapActions('AdressStore', ['fetchStates', 'fetchCities']),
    ...mapActions('TranshipmentStore', [
      'createNegotiationCity',
      'createNegotiationCNPJ',
      'fetchNegotiationByID',
      'editNegotiationCity',
      'editNegotiationCNPJ'
    ]),

    onSubmitConfirm() {
      return this.isEdit ? this.editNegociation() : this.createNegociation();
    },

    async createNegociation() {
      this.isButtonLoading = true;

      const negociationType = {
        city: { key: 'cityId', value: this.cityId, createFunction: 'createNegotiationCity' },
        cnpj: { key: 'cpfOrCnpj', value: removeCaracters(this.cpfOrCnpj), createFunction: 'createNegotiationCNPJ' }
      };

      const { key, value, createFunction } = negociationType[this.selectedType];

      let params = {
        negotiationId: this.negotiationId,
        price: !this.isPercentage ? Number(removePriceMask(this.value)) : null,
        percentage: this.isPercentage ? Number(removePercentageMask(this.percentage)) : null,
        minimumValue: this.isPercentage ? Number(removePriceMask(this.valueMin)) : null,
        [key]: value
      };

      try {
        const status = await this[createFunction](params);

        if (status.success) {
          this.errorsType = 'success';
          this.errors = ['Tarifa criada com sucesso!'];
          this.$emit('shouldRefresh');
          this.close();
        } else {
          this.errorsType = 'error';
          this.errors = status.errors;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isButtonLoading = false;
      }
    },

    async editNegociation() {
      this.isButtonLoading = true;

      const negociationType = {
        city: { key: 'cityId', value: this.cityId, editFunction: 'editNegotiationCity' },
        cnpj: { key: 'cpfOrCnpj', value: removeCaracters(this.cpfOrCnpj), editFunction: 'editNegotiationCNPJ' }
      };

      const { key, value, editFunction } = negociationType[this.selectedType];
      const { id } = this.negociationIdToEdit.data;

      let params = {
        id,
        transhipmentId: this.transhipmentId,
        price: !this.isPercentage ? Number(removePriceMask(this.value)) : null,
        percentage: this.isPercentage ? Number(removePercentageMask(this.percentage)) : null,
        minimumValue: this.isPercentage ? Number(removePriceMask(this.valueMin)) : null,
        [key]: value
      };

      try {
        const status = await this[editFunction](params);
        if (status.success) {
          this.errorsType = 'success';
          this.errors = ['Tarifa editada com sucesso!'];
          this.$emit('shouldRefresh');
          this.close();
        } else {
          this.errorsType = 'error';
          this.errors = status.errors;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isButtonLoading = false;
      }
    },

    async fetchMyNegotiationByID() {
      this.isNegociationLoading = true;

      const { isCnpj } = this.negociationIdToEdit;
      const { id } = this.negociationIdToEdit.data;
      const params = {
        isCnpj,
        id
      };

      try {
        if (isCnpj) {
          const data = await this.fetchNegotiationByID(params);
          this.selectedType = 'cnpj';
          const { price, cpfOrCnpj, percentage, minimumValue } = data;
          this.value = stringToMoneyMask(price);
          this.percentage = percentage ? stringToMoneyMask(percentage) : '0.00%';
          this.valueMin = stringToMoneyMask(minimumValue);
          this.cpfOrCnpj = cpfOrCnpj;
        } else {
          const data = await this.fetchNegotiationByID(params);
          this.selectedType = 'city';
          const { price, stateId, cityId, percentage, minimumValue } = data;
          this.value = stringToMoneyMask(price);
          this.percentage = percentage ? stringToMoneyMask(percentage) : '0.00%';
          this.valueMin = stringToMoneyMask(minimumValue);
          this.stateId = stateId;
          await this.fetchCitiesByID();
          this.cityId = cityId;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.isNegociationLoading = false;
      }
    },

    async fetchCitiesByID() {
      this.loadingCity = true;
      try {
        await this.fetchCities(this.stateId);
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingCity = false;
      }
    },

    async fetchAllStates() {
      try {
        await this.fetchStates();
      } catch (err) {
        console.error(err);
      }
    },

    transformPriceToSend(element) {
      if (!element) return null;
      var money = element.toString().trim();
      money = money.replace('R$ ', '').replaceAll('.', '').replace(',', '.');
      return Number(money);
    },

    transformPercentageToSend(element) {
      if (!element) return null;
      var percentage = element.toString().trim();
      percentage = percentage.replace('%', '').replace(',', '.');
      return Number(percentage);
    },

    resetNegociation() {
      setTimeout(() => {
        this.selectedType = 'city';
        this.cpfOrCnpj = null;
        this.value = null;
        this.stateId = null;
        this.cityId = null;
        this.valueMin = null;
        this.percentage = '0.00%';
        this.forceReset = this.forceReset + 1;
      }, 100);
    },

    close() {
      this.$emit('update:isOpen', false);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.v-input__slot {
  margin: 0;
  padding: 0;

  &::after,
  &::before {
    display: none !important;
  }
}
::v-deep.v-input {
  .v-text-field {
    &__details {
      padding-top: 2x;
      display: inline-block;
    }
  }
}
.v-dialog > .v-card > .v-card__text {
  padding: 0 24px 10px;
}
</style>
